/**
=========================================================
* Material Dashboard 2 PRO React - v2.2.0
=========================================================
*/

import PropTypes from "prop-types";
import { useMemo } from "react";

// Material Dashboard 2 PRO React components
import MDInput from "components/MDInput";

function FormField({ label, value, InputLabelProps, ...rest }) {
  const internalShouldShrink = useMemo(() => {
    const val = value ?? rest.inputProps?.value;
    return val != null && val !== undefined && (typeof val !== "string" || val.trim() !== "");
  }, [value, rest.inputProps?.value]);

  const finalInputLabelProps = {
    shrink: internalShouldShrink,
    ...InputLabelProps,
  };

  return (
    <MDInput
      {...rest}
      variant="outlined"
      label={label}
      fullWidth
      value={value}
      InputLabelProps={finalInputLabelProps}
    />
  );
}

// typechecking props for FormField
FormField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.any,
  InputLabelProps: PropTypes.object,
};

export default FormField;
